/** Shapes shared by the notification + messaging UI (mirror the server's JSON). */

export interface NotificationItem {
  id: number;
  kind: string; // 'message' | 'release' | …
  title: string;
  body: string;
  ref_type: string | null; // 'thread' | 'broadcast' | 'release' | …
  ref_id: string | null;
  actor: string;
  read: boolean;
  created_at: string;
}

export interface Contact {
  id: number;
  username: string;
  name: string;
  role: string;
}

export interface Message {
  id: number;
  from_user: number;
  from_username: string;
  from_name: string;
  to_user: number | null;
  body: string;
  voice_doc_id: number | null;
  ref_type: string | null;
  ref_id: string | null;
  created_at: string;
  mine: boolean;
}

/** Which conversation the messaging panel is showing. */
export type Selection = { kind: 'broadcast' } | { kind: 'user'; userId: number; name?: string };

/** A record a message is ABOUT — set when the drawer is opened from that record (e.g. a deal). The message
 *  is tagged with it (server ref_type/ref_id) so a hand-off like "ship deal 412 today" links back. */
export interface MsgRef {
  type: string; // 'deal' | 'release' | …
  id: string;
  label: string; // human label shown in the composer + on the message chip
}

const FA_DIGITS = '۰۱۲۳۴۵۶۷۸۹';
export const toFaDigits = (s: string | number): string =>
  String(s).replace(/\d/g, (d) => FA_DIGITS[Number(d)]!);

/** Compact Persian "time ago" for notification/message timestamps. */
export function timeAgoFa(iso: string): string {
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return '';
  const secs = Math.max(0, Math.round((Date.now() - then) / 1000));
  if (secs < 60) return 'همین حالا';
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${toFaDigits(mins)} دقیقه پیش`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${toFaDigits(hours)} ساعت پیش`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${toFaDigits(days)} روز پیش`;
  return toFaDigits(new Date(iso).toLocaleDateString('fa-IR'));
}

/** mm:ss for the recording timer. */
export const clock = (secs: number): string =>
  toFaDigits(`${Math.floor(secs / 60)}:${String(secs % 60).padStart(2, '0')}`);
